interface GlobalLoaderProps {
	show: boolean
	label?: string
}

const GlobalLoader = ({ show, label = 'Loading...' }: GlobalLoaderProps) => {
	if (!show) return null

	return (
		<div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/35 backdrop-blur-[2px]" role="status" aria-live="polite" aria-label={label}>
			<div className="flex min-w-[10rem] flex-col items-center gap-3 rounded-app border border-[hsl(var(--primary))]/25 bg-[hsl(var(--card))] px-6 py-5 text-[hsl(var(--card-foreground))] shadow-2xl">
				<div className="h-12 w-12 animate-spin rounded-full border-4 border-[hsl(var(--primary))]/25 border-t-[hsl(var(--primary))]" />
				<span className="text-sm font-medium text-[hsl(var(--muted-foreground))]">{label}</span>
			</div>
		</div>
	)
}

export default GlobalLoader
